<template>
  <div
    :class="[
      'tw-flex tw-cursor-pointer tw-justify-between tw-items-center tw-rounded-lg tw-py-2 tw-px-4 tw-font-poppins tw-font-medium tw-text-sm',
      { 'tw-bg-white tw-text-[#1F2229]': checked }
    ]"
    @click="toggle"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <i
        :class="{
          'fas fa-check-circle': checked,
          'far fa-circle tw-color-white tw-opacity-50': !checked,
        }"
        :style="{ color: checked ? color : '' }"
      />
      {{ portfolio.name }}
    </div>
    <div>
      <i
        class="fas fa-circle tw-hidden"
        :style="{ color }"
      />
    </div>
  </div>
</template>

<script>
import AdvisorCoreCheckbox from '@frontend/ui/components/utils/AdvisorCoreCheckbox.vue';

export default {
  components: {
    AdvisorCoreCheckbox,
  },
  props: {
    portfolio: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: '#EEEFF2',
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {

  },
  methods: {
    toggle() {
      // this.checked = !this.checked;
      // console.log(`Changing checked to ${this.checked}`);
      // this.$nextTick(() => this.$emit('onChecked', this.checked));
      setTimeout(() => this.$emit('onChecked', !this.checked), 0);
    },
  },
};
</script>

<style>

</style>
